module.exports = {"TXTWCL_Claim_your_bonus":{"id":"TXTWCL_Claim_your_bonus","defaultMessage":"Obtenez votre bonus","track":"Claim your bonus"}}